export default __webpack_public_path__ + "static/media/xalingo.3cc084b4.png";